import apiFetch from '../../apiFetch'

export default function (dealerNumber, vinChassis, licensePlate, makerNumber, token, organizedUnitId, dossierSubtypeId) {
  const queryParamsArray = [
    `organizedUnitId=${organizedUnitId}`,
    dealerNumber ? `dealerNumber=${dealerNumber}` : null,
    vinChassis ? `vinChassis=${vinChassis}` : null,
    licensePlate ? `licensePlate=${licensePlate}` : null,
    makerNumber ? `makerNumber=${makerNumber}` : null,
    dossierSubtypeId ? `dossierSubtypeId=${dossierSubtypeId}` : null
  ]
  const queryParams = queryParamsArray.reduce(
    (result, query, idx) => result + (query ? (result ? `&${query}` : `?${query}`) : '')
    , ''
  )
  return apiFetch({ endPoint: `dossier/purchaseWithVehicle${queryParams}`, method: 'GET', token: token })
}
